import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';

import { DEFAULT_CROSS_CUTTING_TASK } from './const';
import { CROSS_CUTTING_TASK_ACTIONS_NAME, CROSS_CUTTING_TASK_MUTATIONS_NAME } from './name';
import { crossCuttingTaskState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function getCrossCuttingTasksMpk(
  context: ActionContext<crossCuttingTaskState, unknown>,
  payload: TBaseFilterPayload<{ countryId: string }>,
) {
  const res: Record<string, any> = await request(
    context,
    {
      url: links.crossCuttingTask.getCrossCuttingTasksMpk,
      mutate: CROSS_CUTTING_TASK_MUTATIONS_NAME.setCrossCuttingTaskMpk,
      name: CROSS_CUTTING_TASK_ACTIONS_NAME.getCrossCuttingTasksMpk,
      abortController: payload.abortController,
    },
    payload.params,
  );

  if (!res?.success) {
    context.commit(CROSS_CUTTING_TASK_MUTATIONS_NAME.setCrossCuttingTaskMpk, { data: DEFAULT_CROSS_CUTTING_TASK });
  }

  return res;
}
